const collectionPassword = document.querySelector('.collection-password-v2');
const HeaderBlock = document.querySelector('#header-main-wrapper');

function setPasswordCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

function getPasswordCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

if (collectionPassword) {
  const pagePasswordForm = collectionPassword.querySelector('.plp-password-form');
  const encodedPassword = pagePasswordForm?.getAttribute('data-password');
  let expectedPassword = ''
  if(encodedPassword){
    expectedPassword = atob(encodedPassword);
  }
  const cookieKey = 'CollectionPassword';

  if (getPasswordCookie(cookieKey) === expectedPassword) {
    collectionPassword.style.display = "none";
    HeaderBlock.style.display = "block";
    const header = HeaderBlock.querySelector('.section-header');
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    document.querySelector('html').classList.remove('no-scroll');
    document.querySelector('body').classList.remove('no-scroll');
    document.querySelector('.CollectionMain')?.classList.remove('hidden');
  } else {
    document.querySelector('html').classList.add('no-scroll');
    document.querySelector('body').classList.add('no-scroll');
     document.querySelector('.CollectionMain')?.classList.add('hidden'); 

    const cookieDays = parseInt(collectionPassword.getAttribute("data-days")) || 1;
    const pagePasswordInput = collectionPassword.querySelector('.password-form input[name=plp-password]');
    const pagePasswordSubmit = collectionPassword.querySelector('.password-form .plp-submit');
    const passwordError = collectionPassword.querySelector('.password-error');

    if (pagePasswordForm && pagePasswordInput) {
      pagePasswordForm.addEventListener("submit", (e) => {
          e.preventDefault();
        if (pagePasswordInput.value.toLowerCase() === expectedPassword) {
          collectionPassword.style.display = "none";
          HeaderBlock.style.display = "block";
          const header = HeaderBlock.querySelector('.section-header');
          document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
          document.querySelector('html').classList.remove('no-scroll');
          document.querySelector('body').classList.remove('no-scroll'); 
           document.querySelector('.CollectionMain').classList.remove('hidden');
          setPasswordCookie(cookieKey, expectedPassword, cookieDays);
        }
        else {
         passwordError.classList.remove("hidden");
        }
      });
    }
  }
}

function setPasswordCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

function getPasswordCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
  }

  connectedCallback() {
    const endDateRaw = this.dataset.endDate; 
    const endHour = this.dataset.endHour || "00:00"; 
    const mainPlp = document.querySelector('.collection-password-v2');
    
    const signUp = document.querySelector('.plp-signup');
    const signUpForm = signUp?.getAttribute('data-signup-hidden');
    const live = this.querySelector('.countdown-live');
    const ended = this.querySelector('.countdown-ended');

    if (!endDateRaw || !live || !ended) return;
    const [day, month, year] = endDateRaw.split('/');
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const endTime = new Date(`${formattedDate}T${endHour}`);

    const update = () => {
      const now = new Date();
      const diff = endTime - now;

      if (diff <= 0) {
        live.style.display = 'none';
        ended.style.display = 'block';
        mainPlp.classList.add('zero_countdown');
        if(signUp){ if(signUpForm == "true"){signUp.classList.add('hidden')} }
        clearInterval(this.timer);
        return;
      }

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);

      this.querySelector('.days').textContent = String(d).padStart(2, '0');
      this.querySelector('.hours').textContent = String(h).padStart(2, '0');
      this.querySelector('.minutes').textContent = String(m).padStart(2, '0');
      this.querySelector('.seconds').textContent = String(s).padStart(2, '0');
    };

    this.timer = setInterval(update, 1000);
    update();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
}

customElements.define('password-countdown', Countdown);


class CustomerSignin extends HTMLElement {
  constructor() {
    super();
    this.togglePasswordHideShow();
    // this.setupValidation();
    this.emailMarketing();
    this.handleMessage();
  }

  togglePasswordHideShow() {
    const passwordInput = this.querySelector('.plp-password input');
    const passwordWrapper = this.querySelector('.plp-password .hide-show-wrapper');
    const passwordHide = passwordWrapper?.querySelector('.passwod_hidden');
    const passwordShow = passwordWrapper?.querySelector('.password_show');

    if (!passwordInput || !passwordWrapper) return;

    const toggleVisibility = () => {
      const hasValue = !!passwordInput.value.trim() ||
                       passwordInput.hasAttribute('data-autofilled') ||
                       passwordInput.matches(':-webkit-autofill') ||
                       passwordInput.matches(':autofill') ||
                       passwordInput.classList.contains('autofill');

      passwordWrapper.style.display = hasValue ? 'block' : 'none';
      passwordWrapper.style.visibility = hasValue ? 'visible' : 'hidden';
      passwordWrapper.classList.toggle('hidden', !hasValue);
    };

    // Listen to events that might change the value
    ['input', 'change', 'focus', 'blur'].forEach(event =>
      passwordInput.addEventListener(event, toggleVisibility)
    );

    // Initial and delayed checks
    [0, 100, 500, 1000, 2000].forEach(delay => setTimeout(toggleVisibility, delay));

    // Handle autofill
    passwordInput.addEventListener('animationstart', (e) => {
      if (e.animationName === 'autofill') {
        setTimeout(toggleVisibility, 100);
      }
    });

    // Fallback for page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', toggleVisibility);
    } else {
      setTimeout(toggleVisibility, 0);
    }

    window.addEventListener('load', toggleVisibility);

    // Mutation observer to detect class/value changes
    new MutationObserver(toggleVisibility).observe(passwordInput, {
      attributes: true,
      attributeFilter: ['value', 'data-autofilled', 'class'],
    });

    // Show/hide toggle
    passwordWrapper.addEventListener('click', () => {
      const isPassword = passwordInput.type === 'password';
      passwordInput.type = isPassword ? 'text' : 'password';
      passwordHide?.classList.toggle('hidden');
      passwordShow?.classList.toggle('hidden');
      passwordInput.focus();
    });
  }

  setupValidation() {
    const form = this.querySelector('form');
    const passwordInput = this.querySelector('.plp-password input');
    const passError = this.querySelector('.pass-error');

    if (!form || !passwordInput || !passError) return;

    form.addEventListener('submit', (e) => {
      const password = passwordInput.value;
      const basicPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
      const repeatPattern = /(.)\1{3,}/;

      if (!basicPattern.test(password) || repeatPattern.test(password)) {
        e.preventDefault();
        passError.classList.remove("hidden");
      }
    }); 
  }

  emailMarketing() {
    const checkbox = this.querySelector("#email_marketing_plp");
    const tagsInput = this.querySelector("#customer_tags_plp");
    // const emailInput = this.querySelector("input[name='customer[email]']");
    if (!checkbox || !tagsInput) return;

    checkbox.addEventListener('change', () => {
      const tags = tagsInput.value.split(',').map(tag => tag.trim()).filter(Boolean);

      if (checkbox.checked) {
        if (!tags.includes('Subscribed')) tags.push('Subscribed');
      } else {
        const index = tags.indexOf('Subscribed');
        if (index !== -1) tags.splice(index, 1);
      }

      tagsInput.value = tags.join(',');
    });
  }

  handleMessage() {
    const mainDiv = this.querySelector('.plp-signup');
    const wrapper = this.querySelector('.plp-signup .plp-signup-wrapper');
    const successBox = this.querySelector('.after-subbmission-success');
    const errorBox = this.querySelector('.after-subbmission-error');
    const alredyUser = this.querySelector('.after-subbmission-alredy-login ');
    const hasAccount = sessionStorage.getItem('hasAccount');
    const has_posted = sessionStorage.getItem('has_posted');
    let hasCustomer = false
    alredyUser.getAttribute('data-customer');
    if(alredyUser.getAttribute('data-customer') == 'true')
    {hasCustomer = true}
    const url = window.location.href;

    if (!wrapper || !successBox || !errorBox) return;

    // if ((url.includes("success=1") && hasAccount == 'true') || (url.includes("customer_posted=true") && has_posted == 'true')) {
    if ((url.includes("success=1") && hasAccount == 'true')) {
      wrapper.classList.add('hidden');
      successBox.classList.remove('hidden');
      errorBox.classList.add('hidden');
      mainDiv.classList.remove('hidden');
      alredyUser.classList.add('hidden');
      sessionStorage.removeItem('has_posted');
      sessionStorage.removeItem('hasAccount');
      // if(url.includes("success=1") && hasAccount == 'true'){
      //   this.querySelector('.hidden_submit').click();
      //    sessionStorage.setItem('has_posted', true);
      // }

    } else if( url.includes("success=1") || hasCustomer == true || url.includes("customer_posted=true")){
      if(url.includes("success=0")){
        wrapper.classList.add('hidden');
        successBox.classList.add('hidden');
        errorBox.classList.remove('hidden');
        mainDiv.classList.remove('hidden');
        alredyUser.classList.add('hidden');
      }
      else{
        wrapper.classList.add('hidden');
        successBox.classList.add('hidden');
        errorBox.classList.add('hidden');
        mainDiv.classList.add('hidden');
        alredyUser.classList.remove('hidden');
      }
    }
    else if (url.includes("success=0")) {
      wrapper.classList.add('hidden');
      successBox.classList.add('hidden');
      errorBox.classList.remove('hidden');
       mainDiv.classList.remove('hidden');
      alredyUser.classList.add('hidden');
    } else {
      wrapper.classList.remove('hidden');
      mainDiv.classList.remove('hidden');
      successBox.classList.add('hidden');
      errorBox.classList.add('hidden');
      alredyUser.classList.add('hidden');
    }
  }
}

customElements.define('customer-signin', CustomerSignin);



// class SvgImage extends HTMLElement {
//   constructor() {
//     super();
//     this.convertImage();
//   }
//   convertImage(){
//     const mainDiv = this.querySelector(".collection-logo");
//     const iamgeUrl = mainDiv?.getAttribute("data-image-url");
//     if(iamgeUrl){
//       fetch(iamgeUrl)
//       .then(response => {
//         if (!response.ok) throw new Error("Network response was not ok");
//         return response.text(); 
//       })
//       .then(svgText => {
//         // console.log('SVG content:', svgText);
//         mainDiv.innerHTML=svgText;

//       })
//       .catch(error => {
//         console.error('Error fetching SVG:', error);
//       });
//     }
//   }
// }
// customElements.define('svg-image', SvgImage);

 document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const successParam = urlParams.get("success");
    if (successParam === "true") {
      if (typeof fbq !== "undefined") {
        fbq('trackCustom', 'FormSubmittedSuccess', {
          form_id: 'create_customer',
          page: window.location.pathname
        });
      }
    }
  });